import React, { useEffect, useState } from 'react'
import { getStatFacturesParMois } from '../../Services/ComptabledashboardService';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, LineChart, Line, PieChart, Pie, Cell } from 'recharts';

export default function StatFacture({exercice,t}) {
    const [statFactures,setStatFactures]=useState([])

    const fetchStatFactures = async () => {
        try {
          const data = await getStatFacturesParMois(exercice);
          console.log("Données reçues de l'API :", data); 
    
          if (data && data.data && typeof data.data === 'object') {
            const years = Object.keys(data.data); 
    
            const monthNames = [
              "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
              "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
            ];
    
            const formattedData = [];
    
            for (let month = 1; month <= 12; month++) {
              const monthData = { mois: monthNames[month - 1] };
    
              years.forEach(year => {
                monthData[year] = data.data[year]?.[month] || 0; 
              });
    
              formattedData.push(monthData);
            }
    
            console.log("Données formatées pour le graphique :", formattedData);
            setStatFactures(formattedData);
          } else {
            console.error("Les données ne sont pas au format attendu :", data);
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des statistiques :", error);
        }
      };
    
    useEffect(()=>{
        fetchStatFactures()
    },[exercice])
    return (

        <div className="card ">
            <div className="card-header  border-0">
                <h4 className="card-title">{t("Nombre de factures par Mois et Année")}</h4>
            </div>
            <div className="card-body">
                <div className="p-5  rounded-lg shadow-md mb-6">
                    <ResponsiveContainer  width="100%" height={300}>
                        <LineChart data={statFactures}>
                            <XAxis dataKey="mois" stroke="#4B5563" />
                            <YAxis stroke="#4B5563" />
                            <Tooltip contentStyle={{ backgroundColor: '#F9FAFB', borderRadius: '8px' }} />
                            <Legend />
                            {Object.keys(statFactures.length > 0 ? statFactures[0] : {}).filter(y => y !== "mois").map(year => (
                                <Line key={year} type="monotone" dataKey={year} stroke={`#${Math.floor(Math.random() * 16777215).toString(16)}`} name={year} />
                            ))}
                        </LineChart>
                    </ResponsiveContainer>
                </div>    </div>
        </div>

    )
}
